<script setup lang="ts">
/* eslint-disable max-len */
export interface IconDelete {
  fill?: string;
  width?: number;
  height?: number;
}
const props = withDefaults(defineProps<IconDelete>(), { fill: "#a9b7d1", width: 16, height: 16 });
</script>

<template>
  <svg :width="props.width" :height="props.height" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.405 2.627h-3.929V1.552c0-.411-.164-.806-.454-1.097A1.548 1.548 0 0 0 9.93 0H7.07c-.41 0-.803.164-1.093.455-.29.291-.454.686-.454 1.097v1.075H1.595a.596.596 0 0 0 0 1.194h1.072v10.15c0 .537.214 1.053.593 1.434.38.38.894.594 1.43.595h7.62c.536 0 1.05-.215 1.43-.595.38-.38.593-.897.593-1.435V3.82h1.072a.596.596 0 0 0 0-1.193zm-8.69-1.075c0-.198.16-.358.356-.358H9.93c.197 0 .357.16.357.358v1.075H6.714V1.552zm.475 10.03a.596.596 0 1 1-1.19 0V7.045a.596.596 0 1 1 1.19 0v4.537zm3.81 0a.596.596 0 1 1-1.19 0V7.045a.596.596 0 1 1 1.19 0v4.537z"
      :fill="props.fill"
      fill-rule="evenodd"
    />
  </svg>
</template>
